module.exports = __webpack_public_path__ + "../resources/img/bg-copy-2-dark.bbb6758c.svg";